import {JSON_FILE_PATH, ADOBE_TARGETING_OBJ_NAME} from 'Constant';
/**
 * Initializes the VF.SAILS object in case it has not been
 * initialized before and adds callback function(s)
 * @param action
 */
export default (action) => {

    // Change json file and load new offers
    const changeJsonFile = (jsonUrl) => {
        jsonUrl = JSON_FILE_PATH + jsonUrl;
        action.getOffers(jsonUrl);
    };

    // Adobe Targeting Object
    initGlobalVFSailsObject(ADOBE_TARGETING_OBJ_NAME, {changeJsonFile});
};

/**
 * Initializes the VF.SAILS object in case it has not been
 * initialized before and adds the special component part
 * @param component
 * @param initialValue
 */
export const initGlobalVFSailsObject = (component, initialValue) => {
    if (undefined !== (window as any).VF) {
        if (undefined === (window as any).VF.SAILS) {
            (window as any).VF.SAILS = {};

        }
        (window as any).VF.SAILS[component] = initialValue;
    }
};
